import { useState } from "react";

const navLinks = [
  { label: "热搜榜", href: "#ranking" },
  { label: "大图流", href: "#flow" },
  { label: "看料目录", href: "#directory" },
  { label: "盘点清单", href: "#roundup" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
              <i className="ri-newspaper-line text-lg" />
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              黑料看料
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-sm" />
              </span>
              <input
                type="text"
                placeholder="搜索人物 / 事件"
                className="h-9 w-44 lg:w-52 rounded-md border border-background-300 bg-background-50 pl-9 pr-3 text-sm text-foreground-950 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-300"
              />
            </div>
            <a
              href="#entry"
              className="flex h-9 items-center gap-1.5 rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-base" />
              下载入口
            </a>
          </div>

          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden cursor-pointer"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#entry"
            onClick={() => setOpen(false)}
            className="mt-3 flex h-10 items-center justify-center gap-1.5 rounded-md bg-primary-500 text-sm font-medium text-background-50 cursor-pointer"
          >
            <i className="ri-download-2-line text-base" />
            下载入口
          </a>
        </div>
      )}
    </header>
  );
}